import React from 'react';
import { Stack } from '@hub/stack';
import { Text } from '@hub/text';
import { LinkOverlay } from '@hub/link';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export const FeatureDetails = _ref => {
  let {
    title,
    body,
    link,
    onClick
  } = _ref;
  return /*#__PURE__*/_jsxs(Stack, {
    shouldWrapChildren: false,
    gap: "spacing-sm",
    "data-id": "mega-menu_feature-details_FeatureDetails_Stack",
    children: [title && /*#__PURE__*/_jsx(Text, {
      lineHeight: "base",
      "data-id": "mega-menu_feature-details_FeatureDetails_Text",
      children: title
    }), body && /*#__PURE__*/_jsx(Text, {
      lineHeight: "base",
      tone: "neutral",
      "data-id": "mega-menu_feature-details_FeatureDetails_Text_2",
      children: body
    }), link && /*#__PURE__*/_jsx(LinkOverlay, {
      href: link.url,
      onClick: onClick,
      "data-id": "mega-menu_feature-details_FeatureDetails_LinkOverlay",
      children: /*#__PURE__*/_jsx(Text, {
        lineHeight: "base",
        decoration: "underline",
        "data-id": "mega-menu_feature-details_FeatureDetails_LinkOverlay_Text",
        children: link.label
      })
    })]
  });
};